import { API_ENDPOINT } from '@constants/configs';
import CustomAxiosInstance from '@utils/axios';

export const apiInstance = new CustomAxiosInstance(API_ENDPOINT);

export default apiInstance;
